/**
 * ProgressionEvents — level-up toast for leveledUp.
 *
 * The server emits this directly to the player who just crossed a level
 * threshold at match end. One NotificationSystem success toast per crossing.
 */

const ProgressionEvents = {
  /**
   * @param {Socket} socket
   * @param {GameState} _gameState
   * @param {Object} callbacks
   * @param {Function} callbacks.notifySuccess
   */
  register(socket, _gameState, callbacks) {
    const { notifySuccess = () => {} } = callbacks;
    socket.on('leveledUp', (data) => {
      const level = data && data.level;
      if (typeof level !== 'number' || !Number.isFinite(level)) return;
      notifySuccess(`Level up! You reached level ${level}.`);
    });
  }
};

export { ProgressionEvents };
